import { render, staticRenderFns } from "./ArticleManager.vue?vue&type=template&id=1801ed3a"
import script from "./ArticleManager.vue?vue&type=script&lang=ts"
export * from "./ArticleManager.vue?vue&type=script&lang=ts"
import style0 from "./ArticleManager.vue?vue&type=style&index=0&id=1801ed3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports